<template>
  <div>
    <div class="label-create-form-data">VIEW CODE</div>
    <span
      class="btn-copy"
      @click="copyCode">
      <i class="fa fa-files-o font-weight-bold cursor-pointer"/> Copy
    </span><br>
    <j-monaco-editor
      v-if="showEditor"
      ref="scriptEditor"
      :value="jsonData"
      :disable="true"
      language="json"
      class="m__t--10"
    />
    <br>
    <b-row>
      <b-col md="6">
        <div style="opacity: 0;">
          <textarea
            id="view-code"
            ref="viewCode"
            :value="viewCode"/>
        </div>
      </b-col>
      <b-col md="6">
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeCodeForm">
            Close
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  components: {
    jMonacoEditor,
  },

  props: {
    jsonData: {
      type: String,
      default: '',
    },
    viewCode: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showEditor: false,
    };
  },

  mounted() {
    setTimeout(() => { this.showEditor = true; }, 100);
  },

  methods: {
    copyCode() {
      const codeToCopy = this.$refs.viewCode;
      codeToCopy.setAttribute('type', 'text');
      codeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line
        alert('Code was copied ' + msg);
      } catch (err) {
        // eslint-disable-next-line
        alert('Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
    },

    closeCodeForm() {
      this.$emit('close-modal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalViewCode.vue